module.exports = aws-sdk;